export const USERS_SET_LOADING = "USERS::SET::LOADING"
export const USERS_SET_ERROR = "USERS::SET::ERROR"
export const USERS_SET_USER = "USERS::SET::USER"
export const USERS_SET_CUSTOMER_LIST = "USERS::SET::CUSTOMER_LIST"
